// import "./MessageText.css";
// import { MEDIA_URL_PREFIX } from "../../stories";

import SaveInfoTooltip from "../save_info_tooltip";

export default function MessageText({ children, className }) {
  const text = new String(children);
  if (text.startsWith("IMAGE:")) {
    // Strip off the "IMAGE:" prefix.
    const baseFilename = text.substring(6);
    const url = baseFilename;
    return (
      <div
        className={`chat__message message-text-image-wrapper ${
          className || ""
        }`}
      >
        <img className="message-text-image" src={url} />
      </div>
    );
  } else if (text.startsWith("SECRET:")) {
    // We assume that secrets come in the form `SECRET:|phonenumber|Mijn gsmnummer is `
    const [, secretName, message] = text.split("|");
    return (
      <div className={`chat__message ${className || ""}`}>
        <div className="">
          <SaveInfoTooltip name={secretName}>{message}</SaveInfoTooltip>
        </div>
      </div>
    );
  } else {
    return (
      <div className={`chat__message ${className || ""}`}>
        <p className="">{children}</p>
      </div>
    );
  }
}
